/**
 * Adjusts the parent's scroll position so the child is visible.
 * This is different than Element.scrollIntoView which also adjusts the scroll positions of all ancestors.
 */
export function scrollIntoView(parent: HTMLElement, child: HTMLElement) {
    let left: number | undefined;
    let top: number | undefined;

    if (
        child.offsetLeft < parent.scrollLeft ||
        child.offsetLeft + child.offsetWidth >
            parent.scrollLeft + parent.offsetWidth
    ) {
        left =
            child.offsetLeft - parent.offsetWidth / 2 + child.offsetWidth / 2;
    }
    if (
        child.offsetTop < parent.scrollTop ||
        child.offsetTop + child.offsetHeight >
            parent.scrollTop + parent.offsetHeight
    ) {
        top =
            child.offsetTop - parent.offsetHeight / 2 + child.offsetHeight / 2;
    }

    if (left !== undefined || top !== undefined) {
        const distance =
            (left !== undefined ? Math.abs(left - parent.scrollLeft) : 0) +
            (top !== undefined ? Math.abs(top - parent.scrollTop) : 0);

        if (parent.scrollTo) {
            parent.scrollTo({
                left,
                top,
                behavior: distance < 500 ? "smooth" : "auto",
            });
        }
    }
}
